import React from 'react';
import { Modal } from 'antd';
import MedicineForm from './MedicineForm';
import { Medicine } from '../../services/medicineService';

interface MedicineModalProps {
  visible: boolean;
  medicine?: Medicine;
  onCancel: () => void;
  onSuccess: () => void;
}

const MedicineModal: React.FC<MedicineModalProps> = ({
  visible,
  medicine,
  onCancel,
  onSuccess,
}) => {
  const isEditing = !!medicine;
  const title = isEditing ? 'Cập nhật sản phẩm' : 'Thêm sản phẩm mới';

  return (
    <Modal
      title={title}
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={1200}
      destroyOnClose
    >
      <MedicineForm
        medicine={medicine}
        onSuccess={() => {
          onSuccess();
          onCancel();
        }}
        onCancel={onCancel}
      />
    </Modal>
  );
};

export default MedicineModal; 